<template>
  <div class="race-list-page">
    <header-pane pageTitle="ROUNDS" />
    <race-list-pane class="race-list-page__contents" />
    <global-navigation-pane current="race" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import HeaderPane from '@/components/common/Header/HeaderPane.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'
import RaceListPane from '@/components/RaceListPage/RaceListPane.vue'

/**
 * レース一覧ページ
 */
export default defineComponent({
  name: 'RaceListPage',
  components: {
    HeaderPane,
    GlobalNavigationPane,
    RaceListPane,
  },
  methods: {},
})
</script>

<style lang="scss" scoped>
.race-list-page {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-items: flex-end;
  justify-content: flex-end;
  width: 100%;
  padding-bottom: env(safe-area-inset-bottom);
  background: $gray1;
}
</style>
